import React, { Fragment } from 'react';
import {FacebookShareButton, PinterestShareButton} from 'react-share';
import PropTypes from 'prop-types';
import Link from 'redux-first-router-link';
import Socials from './Socials';
import OutboundLink from '../common/OutboundLink';
import HeaderBackground from './HeaderBackground';
import SearchForm from '../Search/SearchForm';
import {
  segmentTrackPage, segmentTrackEvent
} from '../../utils';
import { SITE_HOST } from '../../consts';

const handleClick = (e) => {
  const { target } = e;
  const targetTagName = target.tagName.toLowerCase();
  let trackableElement = target;
  let innerHTML = '';
  if ((targetTagName === 'a') || ((targetTagName === 'img') && (target.parentNode.tagName.toLowerCase() === 'a')) || this.props.dataEventName) {
    if (targetTagName === 'img') {
      trackableElement = target.parentNode;
      innerHTML = target.src.substring(target.src.lastIndexOf('/') + 1).split('?')[0];
    } else {
      ({ innerHTML } = target);
    }
  }
  const destinationUrl = trackableElement.getAttribute('href');
  const linkType = trackableElement.getAttribute('data-link-type') || 'text-link';
  const articleClickedTracker = {
    destinationUrl,
    module: 'header-sponsor-logo',
    hypercontext: innerHTML, // need to handle this more elegantly
    category: linkType,
    linkType,
    label: destinationUrl,
  };
  segmentTrackEvent('sponsor_logo_clicked', articleClickedTracker);
}

const isValid = (val) => {
   return (typeof(val) !== 'undefined' && val !== null && val !== '');
 };

const HeaderSimple = ({
  isMobile,
  HeaderLogo,
  sponsoredText,
  sponsoredLogo,
  sponsoredLink,
  HeaderMenuButton,
  standardArticleTracker,
  articleHed,
  articles,
  shareImg,
  shareCopy,
  hedUrl,
}) => {

  let landerUrl = `${SITE_HOST}/`;
  if (!SITE_HOST.includes('-qa') && !SITE_HOST.includes('localhost')) {
    landerUrl = 'https://www.purewow.com/weddings/things-i-wish-i-added-to-my-wedding-registry';
  }

  const shareUrl = isValid(hedUrl) ? `${landerUrl}/${hedUrl}` : landerUrl;
  const pureWowUrl = 'https://www.purewow.com/';

  const shareData = {
    title: articleHed,
    description: shareCopy,
    url: 'https://www.purewow.com/weddings/things-i-wish-i-added-to-my-wedding-registry',
    image: {
      facebook: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/ge-cafe/social/ge-cafe-fb.jpg',
      pinterest: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/ge-cafe/social/ge-cafe-pin.jpg',
    },
    sponsoredLogo,
    sponsoredLink,
  };

  const socialTracker = {
    destinationUrl: shareData.url,
    module: 'social-sharing-button',
    category: 'data-link-type',
    linkType: 'data-link-type',
    label: shareData.title,
  };

  return (  
    <div className="header-scrolling">
      <HeaderBackground />
      <div className="header-contents">
        <div className="header-content">
          {/* {HeaderLogo} */}
          <a className="brand-logo" href={pureWowUrl} rel="noopener norefferer">
              {isMobile ? (
                <img className="brand-mark-img" src="https://static.cdn.gallerymediagroup.com/purewow/logos/purewow-mark-black.svg" alt="PureWow logo" />
              ) : (
                <img className="brand-logo-img" src="https://static.cdn.gallerymediagroup.com/purewow/logos/purewow-logo-black.svg" alt="PureWow mark" />
              )}
          </a>
          {!isMobile &&
            <div className="header-scrolling-article-hed">
              {articleHed}
            </div>
          }
        </div>
        <div className="header-content">
          <ul>
                {(!isMobile && sponsoredLogo) &&
                <li className="sponsored-wrapper">
                  <span className="sponsored">Sponsored By</span>
                <a onClick={e => handleClick(e)} href={sponsoredLink} target="_blank"><img className="sponsored-logo" src={sponsoredLogo} /></a>
                </li>
                }
                <li>
                <div className="btn-social-wrapper"
                  onClick={() => segmentTrackEvent('fb_share_clicked', socialTracker)}>
                    <FacebookShareButton
                      url={shareData.url}
                      quote={shareData.description}
                      className="btn-social btn-social__color--facebook social_click">
                      <span className="icon-facebook btn-social__icon"></span>
                      <span className="btn-social__text">&nbsp;SHARE</span>
                    </FacebookShareButton>
                  </div>
                </li>
                <li>
                  <div className="btn-social-wrapper"
                    onClick={() => segmentTrackEvent('pinterest_share_clicked', socialTracker)}>
                    <PinterestShareButton
                      url={shareData.url}
                      media={shareData.image.pinterest}
                      description={shareData.description}
                      windowWidth={1000}
                      windowHeight={730}
                      className="btn-social btn-social__color--pinterest social_click">
                      <span className="icon-pinterest btn-social__icon"></span>
                      <span className="btn-social__text">&nbsp;PIN IT</span>
                    </PinterestShareButton>
                  </div>
                </li>
              </ul>
        </div>
      </div>
    </div>
  );
};

HeaderSimple.propTypes = {
  isMobile: PropTypes.bool,
  HeaderLogo: PropTypes.node,
  HeaderMenuButton: PropTypes.node,
};

export default HeaderSimple;
